/** Loose match for API labels like "Junior (15–25 years old)" vs stored "Junior". */
export function offerCategoryMatchesOverride(
  offerCustomerType: string,
  overrideAgeCategory: string
): boolean {
  const a = offerCustomerType.trim().toLowerCase();
  const b = overrideAgeCategory.trim().toLowerCase();
  if (a === b) return true;
  return a.includes(b) || b.includes(a);
}
